import React from "react";
import "./WarningPopup.scss";

const WarningPopup = ({
  isOpen,
  onClose,
  onAccept,
  onDecline,
  title = "Warning",
  message = "Are you sure you want to proceed?",
  acceptText = "Accept",
  declineText = "Decline",
}) => {
  if (!isOpen) return null;

  return (
    <div className="warning-popup-overlay" onClick={onClose}>
      <div className="warning-popup" onClick={(e) => e.stopPropagation()}>
        <h2 className="warning-popup-title">{title}</h2>
        <p className="warning-popup-message">{message}</p>
        <div className="warning-popup-actions">
          <button className="warning-popup-button decline" onClick={onDecline}>
            {declineText}
          </button>
          <button className="warning-popup-button accept" onClick={onAccept}>
            {acceptText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningPopup;
